"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeAnimation = void 0;
const fillAnimation_1 = require("./fillAnimation");
const serializeAnimationValue_1 = require("./serializeAnimationValue");
const serializeAnimation = (animation) => {
    const result = [];
    const filled = (0, fillAnimation_1.fillAnimation)(animation);
    for (const key of Object.keys(filled)) {
        const serialized = (0, serializeAnimationValue_1.serializeAnimationValue)(key, filled[key]);
        if (serialized) {
            result.push(serialized);
        }
    }
    return result.join(' ');
};
exports.serializeAnimation = serializeAnimation;
